
export default function generalContent () {

	const wraps = document.querySelectorAll('section.general-content .video .frame[data-video-type]');

	wraps.forEach(function (wrap) {

		const type = wrap.dataset.videoType;

		/*
			No fixed aspect ratio - it's read from the video itself once known,
			so a portrait/square/etc source isn't forced into a wrong box.
		*/
		if (type === 'mp4' && wrap.dataset.mp4) {

			const probe = document.createElement('video');
			probe.preload = 'metadata';
			probe.src = wrap.dataset.mp4;
			probe.addEventListener('loadedmetadata', function () {
				if (probe.videoWidth && probe.videoHeight) {
					wrap.style.aspectRatio = `${probe.videoWidth} / ${probe.videoHeight}`;
				}
			});

		} else if (type === 'youtube' && wrap.dataset.youtube) {

			fetch(`https://www.youtube.com/oembed?url=${encodeURIComponent('https://www.youtube.com/watch?v=' + wrap.dataset.youtube)}&format=json`)
				.then(res => res.ok ? res.json() : null)
				.then(function (data) {
					if (data && data.width && data.height) {
						wrap.style.aspectRatio = `${data.width} / ${data.height}`;
					}
				})
				.catch(function () {});

		}

		const button = wrap.querySelector('.play');
		if (! button) return;

		button.addEventListener('click', function () {

			let media;

			if (type === 'mp4' && wrap.dataset.mp4) {

				media = document.createElement('video');
				media.src = wrap.dataset.mp4;
				media.controls = true;
				media.autoplay = true;
				media.playsInline = true;

			} else if (type === 'youtube' && wrap.dataset.youtube) {

				media = document.createElement('iframe');
				media.src = `https://www.youtube.com/embed/${wrap.dataset.youtube}?autoplay=1&controls=1`;
				media.allow = 'autoplay; encrypted-media; picture-in-picture';
				media.allowFullscreen = true;
				media.frameBorder = '0';

			} else {

				return;

			}

			wrap.querySelectorAll('img, .play').forEach(el => el.remove());
			wrap.appendChild(media);

		});

	});

}



/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on attribute change) without a page reload, so
	'DOMContentLoaded' only covers the first render - re-run init on every
	preview refresh too. ACF's block-preview JS may run in the iframe's own
	window or in the parent admin window depending on context, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=general-content', generalContent);
}
